import React from 'react';
import { Paperclip, X, FileText, Image as ImageIcon } from 'lucide-react';
import { Button } from '../ui/button';
import { PODocumentPicker } from './PODocumentPicker';
import { DOC_LABELS, formatBytes } from './poDocumentRules';

const labelText = (v) => DOC_LABELS.find((l) => l.value === v)?.label || 'Other';

// New PO: files are held here and uploaded right after the PO is created.
export const PendingPODocuments = ({ files, onChange }) => (
  <div className="space-y-2" data-testid="new-po-documents">
    <div className="flex items-center gap-2">
      <Paperclip className="h-4 w-4 text-muted-foreground" />
      <p className="text-sm font-medium">Documents</p>
      <span className="text-xs text-muted-foreground">(optional, attached when the PO is created; not saved with drafts)</span>
    </div>
    <PODocumentPicker source="create" testPrefix="new-po-docs"
      onFiles={(picked, label) => onChange([...files, ...picked.map((file) => ({ file, label, name: file.name }))])} />
    {files.map((f, i) => (
      <div key={`${f.name}-${i}`} className="flex items-center gap-3 rounded-md border px-3 py-2" data-testid={`new-po-doc-${i}`}>
        {f.file.type === 'application/pdf' ? <FileText className="h-4 w-4 text-muted-foreground" /> : <ImageIcon className="h-4 w-4 text-muted-foreground" />}
        <span className="min-w-0 flex-1 truncate text-sm">{f.name}</span>
        <span className="text-xs text-muted-foreground">{labelText(f.label)} · {formatBytes(f.file.size)}</span>
        <Button type="button" size="icon" variant="ghost" className="h-7 w-7" onClick={() => onChange(files.filter((_, j) => j !== i))} data-testid={`new-po-doc-remove-${i}`}><X className="h-4 w-4" /></Button>
      </div>
    ))}
  </div>
);
